import { Container, Image, Message, Select } from "semantic-ui-react"
import logo from "../../assets/logo.png"
import signature from "../../assets/signature.png"
import {useSelector, useDispatch } from "react-redux"
import {setLetterJsOfficer } from "../../redux/projectSlice"

const Step2DetailIneligible = () => {
    const dispatch = useDispatch();
    const projectState = useSelector(state => state.project);

    const handleSelectChange = (e, data) => {
        dispatch(setLetterJsOfficer(data.value));
    }

    const renderHeaderDestination = () => {
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        return (
            <div>
                <Container textAlign='left'>
                    <p>
                        {contact.title} {contact.firstName} {contact.lastName}<br />
                        {lp.nameInEnglish}<br />
                        {lp.addresses[0].houseNumber} {lp.addresses[0].street}<br />
                        {lp.addresses[0].postalCode} {lp.addresses[0].city}<br />
                        {lp.addresses[0].country}<br />
                    </p>
                </Container>
                <Container textAlign='right'>
                    <p>
                        Lille, {projectState.letter?.commission?.step2LetterDate}
                    </p>
                </Container>
            </div>
        )
    }
    
    const getChecklistByName = (name) => {
        let checklist = undefined;
        const checklists =projectState.projectChecklists;
        try {
            for (let i = 0; i < checklists.length; i++) {
                if (checklists[i].name === name) {
                    checklist = checklists[i];
                    return checklist;
                }
            }
        } catch (error) {
            return undefined
        }
    }

    const renderEligibilityFailure = () => {
        const eligibilityChecklistName = projectState.step2Eligibility;
        const eligibilityChecklist = getChecklistByName(eligibilityChecklistName);
        let eligibilityComponents = eligibilityChecklist.detail.components;
        let sortedComponents = eligibilityComponents.slice().sort((a, b) => a.position - b.position);
        let failedEligibility = sortedComponents.filter(component => component.instanceMetadata.answer === 'No');
        console.warn(failedEligibility);
        if (failedEligibility.length === 0) {
            return (<Message negative><Message.Header>There is no negative eligibility reason for this project</Message.Header></Message>)
        } else {
            let eligibilityText = failedEligibility[0].instanceMetadata?.justification + '(eligibility criterion No. ' + failedEligibility[0].programmeMetadata.question +')';
            for (let i=1; i<failedEligibility.length; i++) {
                eligibilityText = eligibilityText + ' and ' + failedEligibility[i].instanceMetadata?.justification + '(eligibility criterion No. ' + failedEligibility[i].programmeMetadata.question +')';
            }
            return (<span>{eligibilityText}</span>)
        }
    }  

    const renderContactPoint = () => {
        const lp = projectState.leadPartner
        let codePays = lp.addresses.filter(address => address.type === 'Organization')[0].countryCode
        if (codePays === 'BE') {
            codePays = lp.addresses.filter(address => address.type === 'Organization')[0].nutsRegion2Code.substring(0, 3)
            console.log(codePays)
        }
        const contactPoints = projectState.letterContactPoints.filter(contactPoint => contactPoint.codePays === codePays)
        if (contactPoints.length === 0) {
            return (<Message negative><Message.Header>We didn't find the contact point for this area: ({codePays})</Message.Header></Message>)
        } else {
            return (
                <span>
                    {contactPoints.map(ct => (
                        <span className="text-accent">{ct.contact} ({ct.email}), </span>
                    ))}
                    the Interreg NWE Contact Point for {contactPoints[0].pays}.
                </span>
            )
        }
    }

    const renderLetter = () => {
        const letter = projectState.letter
        const project = projectState.project
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        const title = project.title.filter(title => title.language === 'EN')[0].translation
        const selectedJsOfficer = projectState.jsOfficers.filter(jsOfficer => jsOfficer.value === letter?.jsOfficer)
        console.warn(project)
        return (
            <Container textAlign='justified' className="espace-haut">
                <p>Dear {contact.title} {contact.lastName},</p>
                { project.callSettings?.endDateStep1 === null ?
                    <p>On behalf of the NWE Monitoring Committee, we regret to inform you that that your Small-Scale Project application <span className="text-accent">{project.customIdentifier} {title} ({project.acronym})</span> has not passed the eligibility check. The reason for the project’s ineligibility is {renderEligibilityFailure()}.</p>
                    :<p>On behalf of the NWE Monitoring Committee, we regret to inform you that your application <span className="text-accent">{project.customIdentifier} {title} ({project.acronym})</span> has not passed the step 2 eligibility check. The reason for the project’s ineligibility is {renderEligibilityFailure()}.</p>
                }
                {/* <p>If you would like more information on this subject, please contact {renderContactPoint()}</p> */}
                <p>If you have questions and would like more information regarding this decision, please contact your responsible JS officer <Select placeholder="Select officer" defaultValue={selectedJsOfficer} options={projectState.jsOfficers} className="invisible-print" onChange={handleSelectChange} /> {!letter?.jsOfficer ? undefined : <span className="invisible-screen">{letter?.jsOfficer[0]} <span className="text-accent">({letter?.jsOfficer[1]})</span></span>}.</p>
                <p>Should you have a complaint regarding this decision, you can find more information regarding the available options in Chapter 7 of the programme manual.</p>
                <p>Kind regards,</p>
                <Image src={signature} size='small' className="espace-haut-large" />
                <p>David Grzegorzewski</p>
                <p>Programme Director</p>
            </Container>
        )
    }

    return (
        <div className="margin-notification-letter">
            <table>
                <thead>
                    <div className="print-margin-top-15mm"></div>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <Container className="notification-letter-logo">
                                <Image src={logo} size='medium' />
                            </Container>
                            <Container textAlign="left">
                                {renderHeaderDestination()}
                            </Container>
                            {renderLetter()}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )

}

export default Step2DetailIneligible;
